// Dependencies
import React, { useRef } from "react";

// Components
import { Area, Menu, AreaMenu } from "@gpstrackit/gtc-react-controls";
import { EmptyState } from "./components/EmptyState";
import { LoadingState } from "./components/LoadingState";
import { DrawerButton } from "./components/DrawerButton";
import { useClipRequestDrawer } from "./useClipRequestDrawer";
import { DrawerSnapshoot } from "./components/DrawerSnapshoot";
import { DrawerVideo } from "./components/DrawerVideo";
import { DrawerEventDetails } from "./components/DrawerEventDetails";
import { DrawerRequestForm } from "./components/DrawerRequestForm";
import { Box } from "@mui/material";

export const ClipRequestDrawerMap = () => {
  const areaMenuRef = useRef();
  const { loading, data, eventUnitTime } = useClipRequestDrawer();
  
  return (
    <AreaMenu
      id="clip-request-drawer-menu"
      ref={areaMenuRef}
      noHideOnBlur={true}
      noCloseAway={false}
    >
      <Area>
        <DrawerButton />
      </Area>
      <Menu
        sx={{
          minWidth: "400px",
          maxWidth: "400px",
          height: "65vh",
          maxHeight: "65vh",
          overflowY: "auto",
          marginTop: "4px",
          borderRadius: "4px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          padding: "16px",
        }}
      >
        {loading && <LoadingState />}
        {!loading && !data?.id && <EmptyState />}
        {data?.id && (
          <Box sx={{maxHeight: "65vh", overflowY: "auto", maxWidth: "350px"}}> 
          {data?.snapshot?.url && <DrawerSnapshoot thumbnailUrl={data?.snapshot?.thumbnailUrl} snapshotUrl={data?.snapshot?.url} />}
          {data?.video?.url && <DrawerVideo videoUrl={data?.video?.url} thumbnailUrl={data?.video?.thumbnailUrl} />}
          <DrawerEventDetails 
            eventName={data?.markerDetail?.vehicleTrail?.eventName} 
            date={eventUnitTime ?? data?.markerDetail?.vehicleTrail?.unitTime}
            timezone={data?.markerDetail?.unit?.timeZone?.name}
            coordinates={`${data?.markerDetail?.vehicleTrail?.latitude}, ${data?.markerDetail?.vehicleTrail?.longitude}`}
            address={data?.markerDetail?.vehicleTrail?.formattedAddress}
            speed={data?.markerDetail?.vehicleTrail?.speed} />
            <DrawerRequestForm deviceId={data?.markerDetail?.linkedDevice?.id} initialDate={eventUnitTime ?? data?.markerDetail?.vehicleTrail?.unitTime} timezone={data?.markerDetail?.unit?.timeZone?.name} />
          </Box>
        )}
      </Menu>
    </AreaMenu>
  );
};
